// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProducts = (client) => ({
    /**
     * `DELETE /vendor/products/:id/attach`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductsIdAttachDelete
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/attach/route.ts
     */
    attach: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/attach", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/products/:id/options/:option_id/attach`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDetachProductOption
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/options/[option_id]/attach/route.ts
     */
    attachOptions: (id, optionId, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/options/:option_id/attach", [id, optionId]), { method: "DELETE", body, query, headers }),
    /**
     * `POST /vendor/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateProduct
     * @source packages/modules/b2c-core/src/api/vendor/products/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/products", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:productId/code-nodes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/[productId]/code-nodes/route.ts
     */
    createCodeNode: (productId, body, query, headers) => client.fetch(buildPath("/vendor/products/:productId/code-nodes", [productId]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/options`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateOptionForProductById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/options/route.ts
     */
    createOption: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/options", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/status`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductStatusById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/status/route.ts
     */
    createStatu: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/status", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/variants`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateVariantForProductById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/variants/route.ts
     */
    createVariant: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/variants", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/variants/:variantId/codes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/variants/[variantId]/codes/route.ts
     */
    createVariantsCode: (variantId, body, query, headers) => client.fetch(buildPath("/vendor/products/variants/:variantId/codes", [variantId]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/products/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/products/:productId/code-nodes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/[productId]/code-nodes/[id]/route.ts
     */
    deleteCodeNode: (productId, id, body, query, headers) => client.fetch(buildPath("/vendor/products/:productId/code-nodes/:id", [productId, id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/products/:id/options/:option_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductOptionById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/options/[option_id]/route.ts
     */
    deleteOption: (id, optionId, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/options/:option_id", [id, optionId]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/products/:id/sample-variant`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDisableProductSampleVariant
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/sample-variant/route.ts
     */
    deleteSampleVariant: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/sample-variant", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/products/:id/variants/:variant_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductVariantById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/variants/[variant_id]/route.ts
     */
    deleteVariant: (id, variantId, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/variants/:variant_id", [id, variantId]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/products/variants/:variantId/codes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/variants/[variantId]/codes/[id]/route.ts
     */
    deleteVariantsCode: (variantId, id, body, query, headers) => client.fetch(buildPath("/vendor/products/variants/:variantId/codes/:id", [variantId, id]), { method: "DELETE", body, query, headers }),
    /**
     * `POST /vendor/products/export`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductsExportCreate
     * @source packages/modules/b2c-core/src/api/vendor/products/export/route.ts
     */
    export: (body, query, headers) => client.fetch("/vendor/products/export", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/import`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductsImportCreate
     * @source packages/modules/b2c-core/src/api/vendor/products/import/route.ts
     */
    import: (body, query, headers) => client.fetch("/vendor/products/import", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProducts
     * @source packages/modules/b2c-core/src/api/vendor/products/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/products", { method: "GET", query, headers }),
    /**
     * `GET /vendor/products/:id/applicable-attributes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductApplicableAttributes
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/applicable-attributes/route.ts
     */
    listApplicableAttributes: (id, query, headers) => client.fetch(buildPath("/vendor/products/:id/applicable-attributes", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/products/:productId/code-nodes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductCodeNodes
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/[productId]/code-nodes/route.ts
     */
    listCodeNodes: (productId, query, headers) => client.fetch(buildPath("/vendor/products/:productId/code-nodes", [productId]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/products/:id/variants`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductVariants
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/variants/route.ts
     */
    listVariants: (id, query, headers) => client.fetch(buildPath("/vendor/products/:id/variants", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/products/variants/:variantId/codes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductCodes
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/variants/[variantId]/codes/route.ts
     */
    listVariantsCodes: (variantId, query, headers) => client.fetch(buildPath("/vendor/products/variants/:variantId/codes", [variantId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/products/:id/attach`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductsIdAttachCreate
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/attach/route.ts
     */
    postAttach: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/attach", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/options/attach`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAttachProductOption
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/options/attach/route.ts
     */
    postAttachOptions: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/options/attach", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/products/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/products/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/products/:productId/code-nodes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/[productId]/code-nodes/[id]/route.ts
     */
    retrieveCodeNode: (productId, id, query, headers) => client.fetch(buildPath("/vendor/products/:productId/code-nodes/:id", [productId, id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/products/variants/:variantId/codes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/variants/[variantId]/codes/[id]/route.ts
     */
    retrieveVariantsCode: (variantId, id, query, headers) => client.fetch(buildPath("/vendor/products/variants/:variantId/codes/:id", [variantId, id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/products/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `PUT /vendor/products/:productId/code-nodes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/[productId]/code-nodes/[id]/route.ts
     */
    updateCodeNode: (productId, id, body, query, headers) => client.fetch(buildPath("/vendor/products/:productId/code-nodes/:id", [productId, id]), { method: "PUT", body, query, headers }),
    /**
     * `POST /vendor/products/:id/options/:option_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductOptionById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/options/[option_id]/route.ts
     */
    updateOption: (id, optionId, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/options/:option_id", [id, optionId]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/publish-release`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductsIdPublishReleaseCreate
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/publish-release/route.ts
     */
    updatePublishRelease: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/publish-release", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/sample-variant`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorEnableProductSampleVariant
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/sample-variant/route.ts
     */
    updateSampleVariant: (id, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/sample-variant", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/products/:id/variants/:variant_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductVariantById
     * @source packages/modules/b2c-core/src/api/vendor/products/[id]/variants/[variant_id]/route.ts
     */
    updateVariant: (id, variantId, body, query, headers) => client.fetch(buildPath("/vendor/products/:id/variants/:variant_id", [id, variantId]), { method: "POST", body, query, headers }),
    /**
     * `PUT /vendor/products/variants/:variantId/codes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/vendor/products/variants/[variantId]/codes/[id]/route.ts
     */
    updateVariantsCode: (variantId, id, body, query, headers) => client.fetch(buildPath("/vendor/products/variants/:variantId/codes/:id", [variantId, id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=products.js.map